// Client-side mirror of the server line-item math (§9.3).
export const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export function computeLine({ qty = 1, rate = 0, discountPct = 0, discountAmt = null, gstIncl = false, taxRate = 0 }) {
  const q = Number(qty) || 0;
  const r = Number(rate) || 0;
  const tr = Number(taxRate) || 0;
  const gross = round2(q * r);
  const dPct = Number(discountPct) || 0;
  const dAmt = discountAmt != null && discountAmt !== '' ? round2(Number(discountAmt)) : round2((gross * dPct) / 100);
  let taxableAmt, gstAmount;
  if (gstIncl) {
    const net = gross - dAmt;
    taxableAmt = round2(net / (1 + tr / 100));
    gstAmount = round2(net - taxableAmt);
  } else {
    taxableAmt = round2(gross - dAmt);
    gstAmount = round2((taxableAmt * tr) / 100);
  }
  return {
    qty: q, rate: r, amount: round2(gross),
    discountPct: dPct, discountAmt: dAmt, gstIncl: !!gstIncl, taxRate: tr,
    taxableAmt, gstAmount, finalAmt: round2(taxableAmt + gstAmount),
  };
}

export function invoiceTotals(items) {
  let subtotal = 0, discountTotal = 0, gstTotal = 0, totalAmount = 0;
  for (const l of items) {
    subtotal += Number(l.amount || l.taxableAmt || 0);
    discountTotal += Number(l.discountAmt || 0);
    gstTotal += Number(l.gstAmount || 0);
    totalAmount += Number(l.finalAmt || 0);
  }
  return {
    subtotal: round2(subtotal), discountTotal: round2(discountTotal),
    gstTotal: round2(gstTotal), totalAmount: round2(totalAmount),
  };
}